import { _PdfBaseStream, _PdfStream } from './base-stream';
export class _PdfDecodeStream extends _PdfBaseStream {
    constructor(maybeMinBufferLength) {
        super();
        this._rawMinBufferLength = maybeMinBufferLength || 0;
        this.offset = 0;
        this.bufferLength = 0;
        this.eof = false;
        this.buffer = new Uint8Array(0);
        this.minBufferLength = 512;
        if (maybeMinBufferLength) {
            while (this.minBufferLength < maybeMinBufferLength) {
                this.minBufferLength *= 2;
            }
        }
    }
    get isEmpty() {
        while (!this.eof && this.bufferLength === 0) {
            this.readBlock();
        }
        return this.bufferLength === 0;
    }
    ensureBuffer(requested) {
        const buffer = this.buffer;
        if (requested <= buffer.byteLength) {
            return buffer;
        }
        let size = this.minBufferLength;
        while (size < requested) {
            size *= 2;
        }
        const buffer2 = new Uint8Array(size);
        buffer2.set(buffer);
        this.buffer = buffer2;
        return this.buffer;
    }
    getByte() {
        const position = this.offset;
        while (this.bufferLength <= position) {
            if (this.eof) {
                return -1;
            }
            this.readBlock();
        }
        return this.buffer[this.offset++];
    }
    getBytes(length) {
        const position = this.offset;
        let end;
        if (length) {
            this.ensureBuffer(position + length);
            end = position + length;
            while (!this.eof && this.bufferLength < end) {
                this.readBlock();
            }
            const bufEnd = this.bufferLength;
            if (end > bufEnd) {
                end = bufEnd;
            }
        }
        else {
            while (!this.eof) {
                this.readBlock();
            }
            end = this.bufferLength;
        }
        this.offset = end;
        return this.buffer.subarray(position, end);
    }
    reset() {
        this.offset = 0;
    }
    makeSubStream(start, length, dictionary) {
        if (length === undefined) {
            while (!this.eof) {
                this.readBlock();
            }
        }
        else {
            const end = start + length;
            while (this.bufferLength <= end && !this.eof) {
                this.readBlock();
            }
        }
        return new _PdfStream(this.buffer, dictionary, start, length);
    }
    getBaseStreams() {
        return this.stream ? this.stream.getBaseStreams() : null;
    }
    moveStart() {
        throw new Error('Invalid call from decode stream');
    }
    getByteRange(begin, end) {
        throw new Error('Invalid call from decode stream. begin: ' + begin + ', end: ' + end);
    }
    readBlock() {
        throw new Error('Invalid call from decode stream');
    }
}
